import React from 'react'
import { Col, Typography } from 'antd'
import { noop } from 'lodash'
import PropTypes from 'prop-types'

import { StyledNoMarginFormItem } from '../styled'

const GridFormItem = ({
  span,
  style,
  className,
  validateStatus,
  help,
  labelAbove,
  label,
  children,
  onClick,
  onMouseEnter,
  onFocus,
  onMouseLeave,
  smallLabel,
}) => {
  let classNames = `${className || ''}`

  if (smallLabel) {
    classNames = `${className || ''} smallLabel`
  }

  return span ? (
    <Col
      span={span}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onFocus={onFocus}
      onMouseLeave={onMouseLeave}
    >
      <StyledNoMarginFormItem
        style={style}
        className={classNames}
        validateStatus={validateStatus}
        help={help}
        label={
          label ? (
            <Typography.Text ellipsis>{label}</Typography.Text>
          ) : undefined
        }
        labelCol={labelAbove ? { span: 24 } : undefined}
      >
        {children}
      </StyledNoMarginFormItem>
    </Col>
  ) : (
    <StyledNoMarginFormItem
      onClick={onClick}
      className={classNames}
      onMouseEnter={onMouseEnter}
      onFocus={onFocus}
      onMouseLeave={onMouseLeave}
      style={style}
      validateStatus={validateStatus}
      help={help}
      label={
        label ? <Typography.Text ellipsis>{label}</Typography.Text> : undefined
      }
      labelCol={labelAbove ? { span: 24 } : undefined}
    >
      {children}
    </StyledNoMarginFormItem>
  )
}

GridFormItem.propTypes = {
  span: PropTypes.number,
  className: PropTypes.string,
  labelAbove: PropTypes.bool,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  children: PropTypes.node.isRequired,
  style: PropTypes.object,
  validateStatus: PropTypes.string,
  help: PropTypes.string,
  onClick: PropTypes.func,
  onMouseEnter: PropTypes.func,
  onFocus: PropTypes.func,
  onMouseLeave: PropTypes.func,
  smallLabel: PropTypes.bool,
}

GridFormItem.defaultProps = {
  span: undefined,
  className: undefined,
  labelAbove: true,
  label: undefined,
  style: undefined,
  validateStatus: undefined,
  help: undefined,
  onClick: noop,
  onMouseEnter: noop,
  onFocus: noop,
  onMouseLeave: noop,
  smallLabel: false,
}

export default GridFormItem
